import { useState, useEffect } from 'react';
import Item from '../../components/Item';
import Paths from '../../constants/paths';
import { useHistory } from 'react-router-dom';
import getScanerFormInput from './getScanerFormInput';
import translations from '../../translations/de';

const NewScanner = ({ store }) => {
    const history = useHistory();
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        !store.dataLoaded && store.setDataLoaded();
    }, [store]);

    return (
        <Item
            links={[{ path: Paths.SCANNERS, name: translations.scanner }]}
            name={`${translations.scanner} ${translations.create}`}
            itemModel={{
                device_id: '',
                title: '',
                app_version: '',
                covid_token: '',
                covid_env: '',
                enabled: false,
            }}
            edit={true}
            onSubmit={(event) => {
                error && setError(null);
                setLoading(true);
                store
                    .addScanner(event)
                    .then(() => {
                        setLoading(false);
                        history.push(Paths.SCANNERS);
                    })
                    .catch((err) => {
                        setError(err);
                        setLoading(false);
                    });
            }}
            onCancel={() => history.goBack()}
            error={error}
            loading={loading}
            determineInputType={({ name, register, error, disabled, index }) =>
                getScanerFormInput({
                    name,
                    register,
                    error,
                    disabled,
                    index,
                })
            }
        ></Item>
    );
};

export default NewScanner;
